export { ProductDetailAccordions } from './ProductDetailAccordions';
